export const healXMessages = {
  noHealX: "No HealX detected in this image.",
  noMeasurement: "Measurement not available"
};
